import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MappaAllertaService } from './mappa-allerta.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription, interval } from 'rxjs';
import { NewModalService } from 'app/generic/new-modal/new-modal.service';

@Component({
  selector: 'widget-mappa-allerta',
  templateUrl: './mappa-allerta.component.html',
  styleUrls: ['./mappa-allerta.component.scss'],
  providers:[MappaAllertaService,  NewModalService]
})
export class MappaAllertaComponent implements OnInit, OnDestroy {

  modelList: any[];
  dataEmissione: any;
  dataDa: any;
  dataA: any;
  numeroAvviso: any;
  anno: any;

  dataEmissioneOggi: any;
  dataDaOggi: any;
  dataAOggi: any;
  numeroAvvisoOggi: any;
  idBollettinoOggi: any;

  dataEmissioneDomani: any;
  dataDaDomani: any;
  dataADomani: any;
  numeroAvvisoDomani: any;
  idBollettinoDomani: any;

  dettaglioAllerta: any[];
  promiseBusy: Promise<any[]>;
  refreshData: boolean = false;
  srcImgZona: any[] = [];
  coloreLivello: {};
  coloreDisplay: string;
  idSelected: Number;
  checkAvviso: boolean;

  interval: Subscription;

  modalOpened: any[] = [];

  defaultColor: any = {
    nome: "VERDE",
    codice: "#A1D511"
  };

  @Input() rifBollettino;

  @HostListener('document:EventPallet', ['$event', '$event.detail.idLivello', '$event.detail.stato', '$event.detail.numeroAvviso'])
  mostraBruttoTesto(event, idLivello, stato, numeroAvviso) {
    //console.log("modalOpened = "+this.modalOpened);
    //if(this.modalOpened == 0)
    this.openModal(idLivello, stato, numeroAvviso);
  }

  @ViewChild('myObject') objectRef: ElementRef;

  constructor(
    public restService: MappaAllertaService,
    private modalService: NgbModal,
    private _sanitizer: DomSanitizer,
    public modalComponent: NewModalService
  ) {
    // Utilizzo corretto di interval
    this.interval = interval(60000 * 5).subscribe(() => {
      this.caricaLivelliAllerta();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    
    // this.caricaLivelliAllerta();
  }

  getDataByRifBollettino() {
    //console.log(this.rifBollettino);
    if (this.rifBollettino == 1) {
      return this.restService.selectAllOggi();
    } else if (this.rifBollettino == 2) {
      return this.restService.selectAllDomani();
    }
  }

  ngOnInit() {

    this.caricaLivelliAllerta();

  }

  getSvgSnap() {

    /* var objectRenderingContext2D = this.objectRef.nativeElement;
    var svg = objectRenderingContext2D.contentDocument;

    var img = new Image;
    img.setAttribute('src',svg);
    document.getElementById('imgLoaderContainer').appendChild(img); */

  }

  caricaLivelliAllerta(){

        //console.log("LivAllerta -> ngOnInit -> " + this.rifBollettino);

        let ref = this;
        ref.srcImgZona = [];
        
            ref.getDataByRifBollettino().then(
              data => {

                this.checkAvviso = data.checkAvviso;
        
                if (ref.rifBollettino == 1) {
        
                  this.dataAOggi = data.dataA;
                  this.dataDaOggi = data.dataDa;
                  this.dataEmissioneOggi = data.dataEmissione;
                  this.numeroAvvisoOggi = data.numeroAvviso;
                  this.idBollettinoOggi = data.idBollettino;
        
                } else if (ref.rifBollettino == 2) {

                  //console.log(this.checkAvviso);
                  if(!this.checkAvviso){
                    this.defaultColor = {
                      nome: "GRIGIO",
                      codice: "#CCC"
                    }
                  }else{
                    this.defaultColor = {
                      nome: "VERDE",
                      codice: "#A1D511"
                    }
                  }
        
                  this.dataADomani = data.dataA;
                  this.dataDaDomani = data.dataDa;
                  this.dataEmissioneDomani = data.dataEmissione;
                  this.numeroAvvisoDomani = data.numeroAvviso;
                  this.idBollettinoDomani = data.idBollettino;
        
                }
        
                this.modelList = data.bollettinoMeteoBindList;
                this.refreshData = true;
        
                var i = 0;
        
                if (data.bollettinoMeteoBindList.length > 0) {
                  data.bollettinoMeteoBindList.forEach(element => {
        
                    (function (element) {
                      ref.coloreLivelloSetup(element, ref);
                      ref.srcImgZona.push(ref.coloreLivello);
                    })(element);
        
                  });
                } else {
                  for (var t = 0; t < 8; t++) {
        
                    ref.srcImgZona.push(ref.defaultColor);
        
                  }
                }
        
                //inizio creazione svg layer
                let objectRenderingContext2D;
        
        
                objectRenderingContext2D = this.objectRef.nativeElement;
        
                objectRenderingContext2D.onload = function () {
        
                  let lvl = objectRenderingContext2D.contentDocument.documentElement.querySelectorAll('path');
        
                  var loadedContext = 0;
                  for (i = 0; i < lvl.length; i++) {
        
                    (function (i) {
        
                      ref.fillSetup(lvl, i, ref);
        
                      //console.log(i + " addEventListener(\"click\") -> " + lvl[i].id);
        
                      lvl[i].addEventListener("click", function (evt) {
        
                        var idLivello;
                        var idZona;
        
                        if (lvl[i].id.indexOf("txt") > -1) {
        
                          var splittedId = lvl[i].id.split("_");
                          idLivello = parseInt(splittedId[1]) - 1;
                          idZona = splittedId[1];
        
                        } else {
        
                          idLivello = parseInt(lvl[i].id) - 1;
                          idZona = lvl[i].id;
        
                        }
                        //console.log((this.id) - 1);
                        //console.log("Click call for " + lvl[i].id);
        
                        var customEvent = document.createEvent("CustomEvent");
                        customEvent.initCustomEvent('EventPallet', false, true,
                          { 'idLivello': idZona, 'stato': ref.modelList[idLivello].livello, 'numeroAvviso': data.idBollettino });
        
                        document.dispatchEvent(customEvent);
        
        
        
                        //ref.openModal(idZona, ref.modelList[idLivello].livello, data.numeroAvviso);
                      });
        
                      loadedContext++;
                      //console.log("loadedContext --> " + loadedContext);
                      if (loadedContext == 27) {
                        ref.caricanomi();
                      }
        
                    })(i);
        
                  }
        
        
                };
                //console.log(ref.modelList.length);
                if (ref.modelList.length > 0) {
                  objectRenderingContext2D.data = "assets/images/campania_zone.svg";
                  //console.log("assets/images/campania_zone.svg");
                } else {
                  objectRenderingContext2D.data = "assets/images/campania_zone_default.svg";
                  //console.log("assets/images/campania_zone_default.svg");
                }

                /* document.getElementById('livContId').style.overflow = 'visible';
                document.getElementById('livContId').style.overflow = 'hidden'; */
        
                //fine creazione svg layer
        
              }
        
        
            );

  }

  caricanomi() {

    var xValue;
    var yValue;
    var j = 1;
    this.srcImgZona.forEach(element => {

      if (j == 1) {

        xValue = '0';
        yValue = '215';

      } else if (j == 2) {

        xValue = '98';
        yValue = '15';

      } else if (j == 3) {

        xValue = '10';
        yValue = '242';

      } else if (j == 4) {

        xValue = '155';
        yValue = '38';

      } else if (j == 5) {

        xValue = '203';
        yValue = '70';

      } else if (j == 6) {

        xValue = '30';
        yValue = '270';

      } else if (j == 7) {

        xValue = '233';
        yValue = '105';

      } else if (j == 8) {

        xValue = '75';
        yValue = '317';

      }

      this.aggiungiElemToSvg('Livello_' + j, element.nome, xValue, yValue);
      j++;

    });

  }

  aggiungiElemToSvg(parentNodeId: string, textContent: string, xValue: string, yValue: string) {

    var a;
    // Get the Object by ID

    a = this.objectRef.nativeElement;
    //console.log(parentNodeId);
    //console.log(a);
    // Get the SVG document inside the Object tag
    var svgDoc = a.contentDocument;
    //console.log(svgDoc);
    // Get one of the SVG items by ID;
    var svgItem = svgDoc.getElementById(parentNodeId).getElementsByTagName('g')[0];


    //var attr = svgItem.getElementsByTagName('polyline')[0].getAttribute('points');
    var newNode = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    newNode.setAttribute('x', xValue);
    newNode.setAttribute('y', yValue);
    newNode.setAttribute('font-size', '10');
    newNode.setAttribute('font-family', 'Verdana');
    newNode.setAttribute('cursor', 'default');
    newNode.setAttribute('pointer-events', 'none');
    newNode.style.fill = '#6b6b6b';
    newNode.style.strokeWidth = '3';
    newNode.innerHTML = textContent;
    svgItem.appendChild(newNode);


  }

  coloreLivelloSetup(element, ref) {


    if (element.livello == 1) {

      ref.coloreLivello = {
        nome: "VERDE",
        codice: "#A1D511"
      };

    } else if (element.livello == 2) {

      ref.coloreLivello = {
        nome: "GIALLA",
        codice: "#F9E933"
      };

    } else if (element.livello == 3) {

      ref.coloreLivello = {
        nome: "ARANCIONE",
        codice: "#fc9e10"
      };

    } else if (element.livello == 4) {

      ref.coloreLivello = {
        nome: "ROSSA",
        codice: "#dc321c"
      };

    } else {

      ref.coloreLivello = {
        nome: "VERDE",
        codice: "#A1D511"
      };

    }

  }

  fillSetup(lvl, i, ref) {
    if (lvl[i].id == "1") {

      if (ref.srcImgZona[0]) {
        lvl[i].style.fill = ref.srcImgZona[0].codice;
      } else {
        lvl[i].style.fill = ref.defaultColor.codice;
      }

    } else if (lvl[i].id == "2") {

      if (ref.srcImgZona[1]) {
        lvl[i].style.fill = ref.srcImgZona[1].codice;
      } else {
        lvl[i].style.fill = ref.defaultColor.codice;
      }

    } else if (lvl[i].id == "3") {

      if (ref.srcImgZona[2]) {
        lvl[i].style.fill = ref.srcImgZona[2].codice;
      } else {
        lvl[i].style.fill = ref.defaultColor.codice;
      }

    } else if (lvl[i].id == "4") {

      if (ref.srcImgZona[3]) {
        lvl[i].style.fill = ref.srcImgZona[3].codice;
      } else {
        lvl[i].style.fill = ref.defaultColor.codice;
      }

    } else if (lvl[i].id == "5") {

      if (ref.srcImgZona[4]) {
        lvl[i].style.fill = ref.srcImgZona[4].codice;
      } else {
        lvl[i].style.fill = ref.defaultColor.codice;
      }

    } else if (lvl[i].id == "6") {

      if (ref.srcImgZona[5]) {
        lvl[i].style.fill = ref.srcImgZona[5].codice;
      } else {
        lvl[i].style.fill = ref.defaultColor.codice;
      }

    } else if (lvl[i].id == "7") {

      if (ref.srcImgZona[6]) {
        lvl[i].style.fill = ref.srcImgZona[6].codice;
      } else {
        lvl[i].style.fill = ref.defaultColor.codice;
      }

    } else if (lvl[i].id == "8") {

      if (ref.srcImgZona[7]) {
        lvl[i].style.fill = ref.srcImgZona[7].codice;
      } else {
        lvl[i].style.fill = ref.defaultColor.codice;
      }

    }

  }

  ngOnDestroy() {

    if(this.interval != null && this.interval != undefined)
      this.interval.unsubscribe();

  }

  getWindowWidth() {
    if (window.innerWidth > 1199) return true;
    else
      return false;
  }

  /*createAllerteList() {

    this.promiseBusy = this.restService.selectAll();
    this.promiseBusy.then(
      res => {
        this.modelList = res;
        this.refreshData = true;
      }
    )

  }*/

  chiamaAlert(element: any) {
    alert(element);
  }

  static lastZone;

  openModal(zona: any, stato: any, idBollettino: any) {

    //console.log("zona = " + zona + " | stato = " + stato);

    if (/* stato > 1 &&  */zona != MappaAllertaComponent.lastZone) {
      MappaAllertaComponent.lastZone = zona;

      var ref = this;

      this.restService.findByIdZona(zona, idBollettino).then(
        data => {

          ref.dettaglioAllerta = data.bollettinoMeteoBindList;
          ref.dataA = data.dataA;
          ref.dataDa = data.dataDa;
          ref.dataEmissione = data.dataEmissione;
          ref.numeroAvviso = data.numeroAvviso;
          ref.anno = data.anno;
          ref.refreshData = true;

          ref.caricaTemplate(data.bollettinoMeteoBindList, data.dataA, data.dataDa, data.dataEmissione, data.numeroAvviso, data.anno);

        }
      );

      //ref.modalOpened = 1;
    }

  }

  caricaTemplate(datiToBind: any[], dataA: string, dataDa: string, dataEmissione: string, numeroAvviso: string, anno: string) {

    var ref = this;
    //console.log("caricatemplate modalOpened = "+ref.modalOpened);
    var stringRischi: String = "";
    var rischi: String = "";
    var alertBoxClass: String = "";
    var zoneCoinvolte: String = "";

    if (datiToBind[0].livello == 1) {
      alertBoxClass = "bg-green";
    } else if (datiToBind[0].livello == 2) {
      alertBoxClass = "bg-orange";
    } else if (datiToBind[0].livello == 3) {
      alertBoxClass = "bg-red-light";
    } else if (datiToBind[0].livello == 4) {
      alertBoxClass = "bg-red";
    }

    if(datiToBind[0].zona == 1){
      zoneCoinvolte = "Piana Campana, Napoli, Isole, Area Vesuviana";
    }else if(datiToBind[0].zona == 2){
      zoneCoinvolte = "Alto Volturno, Matese";
    }else if(datiToBind[0].zona == 3){
      zoneCoinvolte = "Penisola Sorrentino-Amalfitana, Monti di Sarno e Monti Picentini";
    }else if(datiToBind[0].zona == 4){
      zoneCoinvolte = "Alta Irpinia, Sannio";
    }else if(datiToBind[0].zona == 5){
      zoneCoinvolte = "Tusciano, Alto Sele";
    }else if(datiToBind[0].zona == 6){
      zoneCoinvolte = "Piana Sele, Alto Cilento";
    }else if(datiToBind[0].zona == 7){
      zoneCoinvolte = "Tanagro";
    }else if(datiToBind[0].zona == 8){
      zoneCoinvolte = "Basso Cilento";
    }

    stringRischi += '<div class="' + alertBoxClass + '" style="color:white; padding:10px; margin-top:-10px;margin-left: -10px;margin-right: -10px;margin-bottom: 20px;">' +
      '<span style="color: black !important;">LIVELLO DI ALLERTA<br>IDROLOGICA E/O IDRAULICA: </span>' +
      '<span style="color: black !important; font-weight: bold; text-transform: uppercase;">' + datiToBind[0].livelloDesc.split(" ")[6] + '</span>' +
      '</div>' +
      '<div style="background-color: #e6e6e6; color: black !important; padding:10px; margin-top:-10px;margin-left: -10px;margin-right: -10px;margin-bottom: -10px;padding-bottom: 30px;">' +
      '<span>Fenomeni meteo rilevanti: </span></br>';

      if (datiToBind[0].piogge >= 1) {
        rischi += '<span style="font-weight: bold; text-transform: uppercase;">piogge</span></br>';
      }
  
      if (datiToBind[0].temporali >= 1) {
        rischi += '<span style="font-weight: bold; text-transform: uppercase;">temporali</span></br>';
      }
  
      if (datiToBind[0].calore >= 1) {
        rischi += '<span style="font-weight: bold; text-transform: uppercase;">anomalia temperatura</span></br>';
      }
  
      if (datiToBind[0].vento >= 1) {
        rischi += '<span style="font-weight: bold; text-transform: uppercase;">vento</span></br>';
      }
  
      if (datiToBind[0].mare >= 1) {
        rischi += '<span style="font-weight: bold; text-transform: uppercase;">mare</span></br>';
      }
  
      if (datiToBind[0].neve >= 1) {
        rischi += '<span style="font-weight: bold; text-transform: uppercase;">neve</span></br>';
      }
  
      if(rischi == ""){
        rischi = '<span style="font-weight: bold; text-transform: uppercase;">nessuno</span></br>';
      }
  
      stringRischi += rischi + '</div>';

    const activeModal = this.modalService.open(this.modalComponent, { size: 'lg', container: 'nb-layout' });

    activeModal.componentInstance.modalHeader = 'Large Modal';
    activeModal.componentInstance.title = "Livello Allerta Massima ⠂ Zona "+datiToBind[0].zona;
    var strHTML =
      `
    <div class="row" style="width: 100%; padding-left: 6%; font-family: roboto;">
    
      <div class="col-12">
    
            <div class="row" style="padding-left: 2%;">
    
              <div class="col-md-5" style="background-color: #e6e6e6; padding:10px; margin:5px">
                <div style="font-weight: bold">AVVISO N° ` + numeroAvviso + `/` + anno + ` </div>
                <div> ` + dataEmissione + `</div>
              </div>
    
              <div class="col-md-6" style="background-color: #e6e6e6; padding:10px; margin:5px">
                <div style="font-weight: bold">ZONA ` + datiToBind[0].zona + `</div>
                <div>` + zoneCoinvolte + `</div>
              </div>
    
            </div>
    
            <div class="row" style="padding-left: 2%;">
    
              <div class="col-md-5" style="background-color: #e6e6e6; padding:10px; margin:5px">
                <div style="font-weight: bold">INIZIO VALIDITÀ</div>
                <div>` + dataDa + `</div>
                <div style="font-weight: bold; margin-top:5px ">FINE VALIDITÀ</div>
                <div>` + dataA + `</div>
              </div>
    
              <div class="col-md-6" style="padding:10px; margin:5px">
              ` + stringRischi + `
              </div>

            </div>
    
            <div class="row" style="padding-left: 2%;">
    
              <div class="col-md-5" style="padding:10px; margin:5px">
                  <img style="width: 100%; max-width: 300px;" src="assets/images/svgMappeCampania/` 
                  + `zona` + datiToBind[0].zona + `blu.svg` + 
              `"/>
              </div>
    
              <div class="col-md-6" style="background-color: #e6e6e6; padding:10px; margin:5px">
                <div style="font-weight: bold; margin-bottom: 15px;"> 
                  PRINCIPALI SCENARI DI EVENTO ED EFFETTI AL SUOLO:
                </div>
                <div>
                ` + datiToBind[0].scenari + `
                </div>
              </div>
    
            </div>
    
      </div>
    </div>
    `;

    activeModal.componentInstance.htmlToRender = strHTML; //this._sanitizer.bypassSecurityTrustHtml(strHTML);
    //activeModal.componentInstance.headerClass = "bgOnlyFlatBlue";
    activeModal.componentInstance.activeModal = activeModal;
    activeModal.result.then((data) => {
      MappaAllertaComponent.lastZone = -1;
    }, (reason) => {
      MappaAllertaComponent.lastZone = -1;
    });
    //activeModal.close(ref.modalOpened = 0);

  }

}